import { Button, Stack } from '@mui/material';
import React from 'react';
import { matchPath, useLocation } from 'react-router';

import { usePageContext } from '@/context/pageContext/Page.context.ts';
import { useUserContext } from '@/context/userContext/User.context.ts';
import {
  MENU_ITEMS,
  MenuItemModel,
} from '@/layouts/private/topBar/components/sideBarMenu/model/SideBarMenuItems.model.tsx';
import { useAppHistory } from '@/utils/useAppHistory.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

const TopMenuTabs: React.FC = () => {
  const { t } = useTranslationWithPrefix('menu');
  const { setPageDetails } = usePageContext();
  const { role } = useUserContext();
  const location = useLocation();

  const { push } = useAppHistory();

  const handleChangeTab = (newValue: MenuItemModel) => {
    setPageDetails(() => ({ titleId: newValue.id }));
    push(newValue.routes[0]);
  };

  const isMenuItemActive = (menuItem: MenuItemModel): boolean => {
    return menuItem.routes.some(route => {
      const match = matchPath(route, location.pathname);
      return match !== null;
    });
  };

  return (
    <Stack direction="row">
      {MENU_ITEMS.filter(it => it.roles === undefined || it.roles.includes(role)).map(menuItem => {
        const isActive = isMenuItemActive(menuItem);
        return (
          <Button
            key={menuItem.id}
            onClick={() => handleChangeTab(menuItem)}
            startIcon={menuItem.icon}
            sx={{
              ...(isActive && {
                '&:hover': {
                  color: 'primary.dark',
                },
                color: 'primary.main',
              }),
            }}
          >
            {t(menuItem.id)}
          </Button>
        );
      })}
    </Stack>
  );
};

export default TopMenuTabs;
